import React from 'react';
import { GOLD, BOOKING_GOLD } from '../../constants/booking';
import { isTimeRangeAvailable } from './bookingHelpers';

const sectionTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginBottom: '1rem',
  color: '#F5F0E8',
};

export default function DurationPicker({
  durationOptions,
  durationHours,
  minHoursForPackage,
  selectedPackage,
  selectedTime,
  tentativeBookingHours,
  bookedTimes,
  getMaxAvailableHoursForTime,
  onDurationSelect,
  isMobile,
  introText,
}) {
  const isFlatRate = !!selectedPackage?.flatRate;

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h3 style={{ ...sectionTitleStyle, display: 'flex', alignItems: 'center' }}>
        Duration
      </h3>

      <p style={{ fontSize: '0.875rem', color: '#F5F0E8', marginBottom: '1rem' }}>
        {introText != null ? (
          introText
        ) : isFlatRate ? (
          <>
            {selectedPackage.name} events are locked at{' '}
            <span style={{ color: BOOKING_GOLD, fontWeight: '600' }}>
              {minHoursForPackage} hours
            </span>{' '}
            for a flat{' '}
            <span style={{ color: BOOKING_GOLD, fontWeight: '600' }}>
              ${selectedPackage.basePrice.toLocaleString()}
            </span>
            .
          </>
        ) : (
          <>
            {minHoursForPackage}-hour minimum included in base price.
            {selectedPackage && (
              <>
                {' '}
                Additional hours billed at{' '}
                <span style={{ color: BOOKING_GOLD, fontWeight: '600' }}>
                  ${selectedPackage.hourlyRate}/hr
                </span>
                .
              </>
            )}
          </>
        )}
      </p>

      <div className="dd-duration-row" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
        {durationOptions.map((hours) => {
          const isSelected = durationHours === hours;
          const disabled =
            isFlatRate ||
            (selectedTime &&
              (!isTimeRangeAvailable(selectedTime, hours, bookedTimes) ||
                hours > getMaxAvailableHoursForTime(selectedTime)));

          return (
            <button
              key={hours}
              type="button"
              onClick={() => !disabled && onDurationSelect(hours)}
              disabled={disabled}
              style={{
                flex: isMobile ? '1 1 calc(33% - 0.5rem)' : '0 0 auto',
                minWidth: isMobile ? '5rem' : '4.5rem',
                padding: '0.75rem 1.25rem',
                borderRadius: '0.75rem',
                border: isSelected ? `2px solid ${GOLD}` : '1px solid #4b5563',
                backgroundColor: isSelected ? GOLD : disabled ? '#0a0a0a' : '#1a1a1a',
                color: isSelected ? '#000000' : disabled ? '#6b7280' : '#F5F0E8',
                fontWeight: '700',
                fontSize: '1rem',
                cursor: disabled ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                opacity: disabled ? 0.5 : 1,
              }}
            >
              {hours} hrs
            </button>
          );
        })}
      </div>

      {selectedTime && tentativeBookingHours.length > 0 && (
        <p
          style={{
            fontSize: '0.875rem',
            color: '#F5F0E8',
            marginTop: '1rem',
            padding: '0.5rem',
            backgroundColor: '#111111',
            borderRadius: '0.5rem',
            border: '1px solid rgba(201, 168, 76, 0.2)',
          }}
        >
          Booking window: {selectedTime} – {tentativeBookingHours[tentativeBookingHours.length - 1]}
        </p>
      )}
    </div>
  );
}
